<template>
	<div
	v-touch:tap="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	style="user-select: none;"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>

		<template v-if="data">

			<button class="btn btn-danger float-right" v-if="showDeleteBtn" v-touch:tap.stop="deleteItem">{{$t('delete')}}</button>

			<p>{{ data.formlibrary_title }}</p>

		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
export default {
	props: ['data', 'swipedLeftItem', ],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		deleteItem() {
			this.$cfetch(`${this.$settings.APIBaseURL}/formlibrary/deleteitem`, {
				data: {
					id: this.data.formlibrary_id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.data);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {

			// prevent tap for right clicks
			if(e.button && e.button == 2) {
				return false;
			}

			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.data);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.data);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.data);
		},
	},
	computed: {
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.formlibrary_id == this.data.formlibrary_id) && this.$UserSession.hasPriv.call(this, 'EDIT_FORMS');
		},
	}
};
</script>
